export default "__VITE_ASSET__DEFjLOaY__"